<template>
  <ul class="contact-social__list">
    <li class="contact-social__list-item">
      <a
        href="https://www.facebook.com/UNLTDtennis18/"
        class="contact-social__link"
      >
        <FacebookIcon class="contact-social__icon"/>
      </a>
    </li>
    <li class="contact-social__list-item">
      <a
        href="https://www.instagram.com/unltdtennis/"
        class="contact-social__link"
      >
        <InstagramIcon class="contact-social__icon"/>
      </a>
    </li>
  </ul>
</template>

<script>

  import FacebookIcon from './FacebookIcon';
  import InstagramIcon from './InstagramIcon';
  import YoutubeIcon from './YoutubeIcon';

  export default {
    components: {
      FacebookIcon,
      InstagramIcon,
      YoutubeIcon,
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .contact-social__list {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: spacing(base-epsilon);
    padding-bottom: spacing(base-epsilon);

    @include breakpoint(phablet) {
      flex-direction: row;
      justify-content: center;
      padding-top: spacing(base-eta);
      padding-bottom: spacing(base-eta);
    }
  }
  .contact-social__list-item {
    margin-bottom: spacing(base-epsilon);

    &:last-child {
      margin-bottom: 0;
    }

    @include breakpoint(phablet) {
      margin-right: spacing(base-delta);
      margin-bottom: 0;
      margin-left: spacing(base-delta);

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .contact-social__link {

    &:hover,
    &:focus {
      .contact-social__icon {
        fill: color(red);
        transition-timing-function: timing-function(decelerate);
      }
    }
  }

  .contact-social__icon {
    width: 35px;
    fill: color(bronze);
    transition-property: fill;
    transition-timing-function: timing-function(accelerate);
    transition-duration: duration(fast);

    @include breakpoint(phablet) {
      width: 40px;
    }
  }
</style>
